import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteHeaderComponent } from './website-header.component'
import { AnchorService, RichsnipetService } from 'dmmp-services'
import { SharedModule } from '../shared/shared.module'
import { RouterModule } from '@angular/router'
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module'
import { FormsModule } from '@angular/forms'
import { NgxJsonLdModule } from 'ngx-json-ld'
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    BreadcrumbModule,
    FormsModule,
    NgxJsonLdModule,
  ],
  declarations: [WebsiteHeaderComponent],
  exports: [WebsiteHeaderComponent],
  providers: [AnchorService, RichsnipetService],
})
export class WebsiteHeaderModule {}
